module.exports = __webpack_public_path__ + "img/refah.309cd77.png";